import { render } from "./EditingSectionPxapp.vue?vue&type=template&id=49cc3a1e"
import script from "./EditingSectionPxapp.vue?vue&type=script&lang=js"
export * from "./EditingSectionPxapp.vue?vue&type=script&lang=js"
script.render = render

export default script